import { Component, Input } from '@angular/core';
import { IMailAttachmentsType } from 'src/app/shared/models/mail/mail.model';
import { IMessage } from 'src/app/shared/models/message/message.model';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-message-item-attachments',
  standalone: true,
  imports: [],
  templateUrl: './message-item-attachments.component.html',
  styleUrl: './message-item-attachments.component.scss'
})
export class MessageItemAttachmentsComponent {

  @Input({required: true}) message: IMessage | undefined;

  constructor(
    private utils: UtilsService
  ) {}


  
  onAttachment(att: IMailAttachmentsType) {
    try {
      // Handle href-based attachments
      if ('href' in att && att.href) {
        window.open(att.href, '_blank');
        return;
      }
    
      // Handle content-based attachments
      if ('content' in att && att.content) {
        console.log('onAttachment', att);
    
        let blobContent: BlobPart;
        
        // Handle different content types
        if (typeof att.content === 'string') {
          if (att.encoding === 'base64') {
            // Decode base64 string
            try {
              const binaryString = atob(att.content);
              const bytes = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }
              blobContent = bytes;
            } catch (error) {
              console.error('Failed to decode base64 content:', error);
              this.utils.logError(`Failed to decode base64 content: ${error}`);
              return;
            }
          } else {
            // Handle plain string content
            blobContent = att.content;
          }
        } else if (att.content?.type === 'Buffer' && Array.isArray(att.content.data)) {
          // Handle serialized Buffer
          blobContent = new Uint8Array(att.content.data);
        } else {
          // Handle other content types (assuming it's already in the right format)
          blobContent = att.content as unknown as BlobPart;
        }
    
        // Create blob with proper content type
        const contentType = att.contentType || 'application/octet-stream';
        const blob = new Blob([blobContent], { type: contentType });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = att.filename || 'download';
        a.style.display = 'none'; // Hide the element
        
        // Trigger download
        document.body.appendChild(a);
        a.click();
        
        // Cleanup
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 100); // Small delay to ensure download starts
        
        return;
      }
    
      // Log error for unknown attachment types
      this.utils.logError(`Unknown attachment type ${JSON.stringify(att)}, 1903ruwt8grdfk`);
    } catch (error) {
      console.error('Error handling attachment:', error);
      this.utils.logError(`Error handling attachment: ${error}, 1205329twu8reghi`);
    }
  }
}
